import { Paper, TableContainer, Table, TableCell, TableRow, TableHead, TableBody, Typography, Stack } from "@mui/material";

const Business = ({person}) => {

    let b = person.business || {};

    let ratio = b.deals ? Math.round(b.wins / b.deals * 100) : 0;

    return <Stack spacing={2}>

        <Typography variant='h3'>Commercial</Typography>

        <TableContainer component={Paper}>
            <Table className="person-table">
                <TableHead>
                    <TableRow>
                        <TableCell><b>Affaires créées</b></TableCell>
                        <TableCell><b>Affaires gagnées</b></TableCell>
                        <TableCell><b>Ventes générées</b></TableCell>
                        <TableCell><b>CA généré</b></TableCell>
                        <TableCell><b>Taux de réussite</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>{(b.deals || 0).toLocaleString()}</TableCell>
                        <TableCell>{(b.wins || 0).toLocaleString()}</TableCell>
                        <TableCell>{(b.enrollments || 0).toLocaleString()}</TableCell>
                        <TableCell>{(b.revenue || 0).toLocaleString()}<small>€</small></TableCell>
                        <TableCell>{(ratio || 0).toLocaleString()}<small>%</small></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        
    </Stack>
}

export default Business;